/**
 * Decodifica entidades HTML de um texto (ex.: `Instru&ccedil;&atilde;o` → `Instrução`).
 *
 * Alguns campos vindos da API chegam com entidades HTML não convertidas — por vezes
 * codificadas mais de uma vez (`&amp;ccedil;`, `&amp;amp;ccedil;`). A decodificação é
 * aplicada em múltiplas passagens (até estabilizar, com limite de segurança) para
 * cobrir esses casos, retornando o texto pronto para exibição.
 *
 * Usa o parser do DOM via `<textarea>` (conteúdo RCDATA, não executa scripts);
 * destinado ao uso no cliente.
 *
 * @param value - Texto possivelmente com entidades HTML (aceita `null`/`undefined`)
 * @returns O texto com as entidades convertidas; string vazia para valores ausentes
 *
 * @example
 * ```ts
 * decodeHtmlEntities('Teste de Instru&ccedil;&atilde;o'); // 'Teste de Instrução'
 * decodeHtmlEntities('Instru&amp;amp;ccedil;&amp;amp;atilde;o'); // 'Instrução'
 * ```
 */
export function decodeHtmlEntities(value: string | null | undefined): string {
  if (!value) return '';

  let current = value;
  // Múltiplos passes cobrem valores codificados mais de uma vez.
  for (let i = 0; i < 3 && current.includes('&'); i++) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = current;
    const decoded = textarea.value;
    if (decoded === current) break;
    current = decoded;
  }
  return current;
}
